module.exports = __webpack_public_path__ + "static/media/bg_preview.cc51e80b.png";